module.exports = __webpack_public_path__ + "img/rufus.2bde1709.jpg";